/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

export function validateDwellBaseEvent(event: any): void {
	if (!event) {
		throw new Error('Missing event');
	}

	if (!event.source) {
		throw new Error('Missing event.source');
	}

	if (!event.actionSubject) {
		throw new Error('Missing event.actionSubject');
	}
}
